var map = {
	"./american_express.png": "9940",
	"./logo.png": "9d64",
	"./mastercard.png": "3c3e",
	"./mindfood-dark.png": "b3e2",
	"./mindfood-light.png": "414c",
	"./mindfood-solutions.png": "431b",
	"./profile.png": "b31e",
	"./visa.png": "a236"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";